import { FormatHeaderEqualIcon } from './FormatHeaderEqualIcon';

/**
 * author: Andreas Gohr
 * id 99554AA1-419F-420F-9AEB-0826D411B420
 * name format-header-equal
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/format-header-equal.svg
 * tags
 * - Text / Content / Format 
 */
export const FormatHeadingEqualIcon = FormatHeaderEqualIcon;
export default FormatHeadingEqualIcon